// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20-My","type":"styles_type__lwv7o","choices":"styles_choices__I86o3"};